import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import {
  StyledCenteredText,
  StyledStack,
} from '@webclient/components/search-forms/gamification-search/actions/filters/components/selection-tabs/styles';

import { Text } from '@knowz/knowz-ui';

type Props = {
  title: string;
  subtitle: string;
  Icon: React.ReactElement;
  children: React.ReactNode;
  sx: SxProps;
  direction?: 'row' | 'column';
};

export default function SelectionTabs({
  Icon,
  children,
  subtitle,
  title,
  sx,
  direction = 'column',
}: Props) {
  const isItRowDir = direction === 'row';
  return (
    <Stack
      gap={3}
      direction={direction}
      sx={{
        justifyContent: isItRowDir ? 'space-between' : 'center',
      }}
    >
      <Stack
        sx={{
          alignItems: isItRowDir ? 'flex-start' : 'center',
        }}
      >
        <StyledStack>
          {Icon}
          <Text
            variant="textLg"
            weight="semibold"
          >
            {title}
          </Text>
        </StyledStack>
        <StyledCenteredText variant="textMd">{subtitle}</StyledCenteredText>
      </Stack>
      <Stack sx={sx}>{children}</Stack>
    </Stack>
  );
}
